import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "react-bootstrap";
import style from "./CompanyValidateModal.module.css";
import { PiWarningFill } from "react-icons/pi";
import { useState } from "react";

function CompanyValidateModal({ close, submit, companiesValidation }) {
  const [loading, setLoading] = useState(false);

  return (
    <Modal
      show={true}
      size="md"
      className={style.zIndexHigher + " " + style.modal}
      centered={true}
      backdropClassName={style.zIndexHigh}
    >
      <ModalHeader className="bg-white">
        <div className={"d-flex align-items-center " + style.icon}>
          <PiWarningFill />
          <h3 className="font-style-none mb-0 me-3">هشدار</h3>
        </div>
      </ModalHeader>

      <ModalBody className="bg-white">
        <div className={style.content}>
          <p className="mb-3">کاربر محترم:</p>
          {companiesValidation.mahex === false && (
            <p className="mb-3">
              شهر انتخابی شما در سرویس <strong>ماهکس</strong> فعال نیست
            </p>
          )}
          {companiesValidation.chapar === false && (
            <p className="mb-3">
              شهر انتخابی شما در سرویس <strong>چاپار</strong> فعال نیست
            </p>
          )}
          {companiesValidation.tipax === false && (
            <p className="mb-3">
              شهر انتخابی شما در سرویس <strong>تیپاکس</strong> فعال نیست
            </p>
          )}
          {companiesValidation.dekapost === false && (
            <p className="mb-3">
              <span>شهر انتخابی شما در سرویس </span>
              <strong>دکاپست</strong>
              <span> فعال نیست</span>
            </p>
          )}
          {companiesValidation.post === false && (
            <div>
              <p>
                شهر انتخابی شما در سرویس <strong>پست</strong> فعال نیست
              </p>
              <p className="mb-3">
                فقط برای سرویس دهنده پست می‌توانید ابتدا در بخش انتخاب شهر
                ،شهرستان مربوطه را وارد نمایید ،سپس در بخش آدرس ،مقصد نهایی را
                بنویسید.
              </p>
              <div></div>
            </div>
          )}
        </div>
      </ModalBody>
      <ModalFooter className="bg-white">
        <button className="btn btn-primary" onClick={close}>
          ویرایش شهر
        </button>
        <button
          className="btn btn-danger d-flex align-items-center"
          onClick={() => {
            submit();
            setLoading(true);
          }}
          disabled={loading === true}
        >
          {loading === true ? (
            <div className="d-flex align-items-center">
              <Spinner
                style={{
                  width: "20px",
                  height: "20px",
                  fontSize: "0.8rem",
                }}
              />
              <span className="me-1"> در حال ثبت</span>
            </div>
          ) : (
            <span>ادامه</span>
          )}
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default CompanyValidateModal;
